function initBannerSliders(root) {
  if (typeof Swiper === 'undefined') {
    return;
  }

  const scope = root || document;
  const bannerSliders = scope.querySelectorAll('.banner-slider-section');

  bannerSliders.forEach(function (slider) {
    if (slider.dataset.swiperInitialized === 'true') {
      return;
    }

    const autoplayDelay = slider.dataset.autoplayDelay ? parseInt(slider.dataset.autoplayDelay, 10) : 3000;
    const autoplayEnabled = slider.dataset.autoplay === 'true';
    const loopEnabled = slider.dataset.loop === 'true';
    const nextButton = slider.querySelector('.swiper-button-next');
    const prevButton = slider.querySelector('.swiper-button-prev');
    const pagination = slider.querySelector('.swiper-pagination');

    new Swiper(slider, {
      loop: loopEnabled,
      autoplay: autoplayEnabled
        ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
          }
        : false,
      navigation: nextButton && prevButton
        ? {
            nextEl: nextButton,
            prevEl: prevButton,
          }
        : false,
      pagination: pagination
        ? {
            el: pagination,
            clickable: true,
          }
        : false,
      a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
      },
    });

    slider.dataset.swiperInitialized = 'true';
  });
}

function initUspSliders(root) {
  if (typeof Swiper === 'undefined') {
    return;
  }

  const scope = root || document;
  const uspSliders = scope.querySelectorAll('.usp-bar__slider');

  uspSliders.forEach(function (slider) {
    const slideCount = slider.querySelectorAll('.swiper-slide').length;
    const shouldEnableMobileSlider = window.innerWidth < 750 && slideCount > 1;

    if (shouldEnableMobileSlider) {
      if (slider.swiper) {
        slider.swiper.update();
        return;
      }

      const autoplayDelay = slider.dataset.autoplayDelay ? parseInt(slider.dataset.autoplayDelay, 10) : 2500;
      const autoplayEnabled = slider.dataset.autoplay === 'true';
      const loopEnabled = slider.dataset.loop === 'true';

      new Swiper(slider, {
        loop: loopEnabled,
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 500,
        allowTouchMove: true,
        autoplay: autoplayEnabled
          ? {
              delay: autoplayDelay,
              disableOnInteraction: false,
            }
          : false,
      });

      return;
    }

    if (slider.swiper) {
      slider.swiper.destroy(true, true);
    }

    slider.style.removeProperty('height');
    slider.style.removeProperty('overflow');

    const wrapper = slider.querySelector('.swiper-wrapper');
    if (wrapper) {
      wrapper.removeAttribute('style');
    }

    slider.querySelectorAll('.swiper-slide').forEach(function (slide) {
      slide.removeAttribute('style');
    });
  });
}

function initShopByCategorySliders(root) {
  if (typeof Swiper === 'undefined') {
    return;
  }

  const scope = root || document;
  const categorySliders = scope.querySelectorAll('.shop-by-category__slider');

  categorySliders.forEach(function (slider) {
    if (slider.dataset.swiperInitialized === 'true') {
      return;
    }

    const panel = slider.closest('.shop-by-category__panel');
    const filters = panel ? panel.querySelectorAll('.shop-by-category__filter') : [];
    const cards = slider.querySelectorAll('.shop-by-category__card');
    const nextButton = slider.querySelector('.shop-by-category__nav--next');
    const prevButton = slider.querySelector('.shop-by-category__nav--prev');
    const desktopCards = slider.dataset.desktopCards ? parseInt(slider.dataset.desktopCards, 10) : 4;
    const gap = slider.dataset.gap ? parseInt(slider.dataset.gap, 10) : 12;

    const swiper = new Swiper(slider, {
      slidesPerView: 1.5,
      spaceBetween: gap,
      speed: 500,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      navigation: nextButton && prevButton
        ? {
            nextEl: nextButton,
            prevEl: prevButton,
          }
        : false,
      breakpoints: {
        750: {
          slidesPerView: 2,
          spaceBetween: gap,
        },
        990: {
          slidesPerView: desktopCards,
          spaceBetween: gap,
        },
      },
      a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
      },
    });

    function setFilter(value) {
      let firstVisibleIndex = -1;

      cards.forEach(function (card, index) {
        const matches = value === 'all' || card.dataset.category === value;
        card.hidden = !matches;

        if (matches && firstVisibleIndex === -1) {
          firstVisibleIndex = index;
        }
      });

      swiper.update();

      window.requestAnimationFrame(function () {
        swiper.update();

        if (firstVisibleIndex > -1) {
          swiper.slideTo(firstVisibleIndex, 0);
        }
      });
    }

    filters.forEach(function (button) {
      button.addEventListener('click', function () {
        filters.forEach(function (item) {
          item.classList.remove('is-active');
        });

        button.classList.add('is-active');
        setFilter(button.dataset.filter || 'all');
      });
    });

    const activeFilter = panel ? panel.querySelector('.shop-by-category__filter.is-active') : null;
    setFilter(activeFilter ? activeFilter.dataset.filter || 'all' : 'all');

    slider.dataset.swiperInitialized = 'true';
  });
}

function initFeaturedBlogPostSliders(root) {
  if (typeof Swiper === 'undefined') {
    return;
  }

  const scope = root || document;
  const blogSliders = scope.querySelectorAll('.featured-blog-posts__slider');

  blogSliders.forEach(function (slider) {
    const slideCount = slider.querySelectorAll('.swiper-slide').length;
    const shouldEnableMobileSlider = window.innerWidth < 750 && slideCount > 1;
    const mobileSlides = slider.dataset.mobileSlides ? parseFloat(slider.dataset.mobileSlides) : 1.3;
    const mobileGap = slider.dataset.mobileGap ? parseInt(slider.dataset.mobileGap, 10) : 16;

    if (shouldEnableMobileSlider) {
      if (slider.swiper) {
        slider.swiper.update();
        return;
      }

      new Swiper(slider, {
        slidesPerView: mobileSlides,
        spaceBetween: mobileGap,
        speed: 500,
        watchOverflow: true,
        observer: true,
        observeParents: true,
      });

      return;
    }

    if (slider.swiper) {
      slider.swiper.destroy(true, true);
    }

    slider.style.removeProperty('height');
    slider.style.removeProperty('overflow');

    const wrapper = slider.querySelector('.swiper-wrapper');
    if (wrapper) {
      wrapper.removeAttribute('style');
    }

    slider.querySelectorAll('.swiper-slide').forEach(function (slide) {
      slide.removeAttribute('style');
    });
  });
}

function initCustomReviewSliders(root) {
  if (typeof Swiper === 'undefined') {
    return;
  }

  const scope = root || document;
  const reviewSliders = scope.querySelectorAll('.custom-reviews__slider');

  reviewSliders.forEach(function (slider) {
    const slideCount = slider.querySelectorAll('.swiper-slide').length;
    const desktopSlides = slider.dataset.desktopSlides ? parseFloat(slider.dataset.desktopSlides) : 1;
    const mobileSlides = slider.dataset.mobileSlides ? parseFloat(slider.dataset.mobileSlides) : 1;
    const desktopGap = slider.dataset.desktopGap ? parseInt(slider.dataset.desktopGap, 10) : 24;
    const mobileGap = slider.dataset.mobileGap ? parseInt(slider.dataset.mobileGap, 10) : 16;
    const sliderSpeed = slider.dataset.speed ? parseInt(slider.dataset.speed, 10) : 500;
    const autoplayDelay = slider.dataset.autoplayDelay ? parseInt(slider.dataset.autoplayDelay, 10) : 3500;
    const autoplayEnabled = slider.dataset.autoplay === 'true';
    const loopEnabled = slider.dataset.loop === 'true';
    const pagination = slider.querySelector('.swiper-pagination');
    const nextButton = slider.querySelector('.custom-reviews__nav--next');
    const prevButton = slider.querySelector('.custom-reviews__nav--prev');

    function resetSliderMarkup() {
      slider.style.removeProperty('height');
      slider.style.removeProperty('overflow');

      const wrapper = slider.querySelector('.swiper-wrapper');
      if (wrapper) {
        wrapper.removeAttribute('style');
      }

      slider.querySelectorAll('.swiper-slide').forEach(function (slide) {
        slide.removeAttribute('style');
      });
    }

    if (slideCount <= 1) {
      if (slider.swiper) {
        slider.swiper.destroy(true, true);
      }

      resetSliderMarkup();
      return;
    }

    if (slider.swiper) {
      slider.swiper.destroy(true, true);
      resetSliderMarkup();
    }

    new Swiper(slider, {
      slidesPerView: mobileSlides,
      spaceBetween: mobileGap,
      speed: sliderSpeed,
      autoHeight: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      loop: loopEnabled,
      autoplay: autoplayEnabled
        ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
          }
        : false,
      pagination: pagination
        ? {
            el: pagination,
            clickable: true,
          }
        : false,
      navigation: nextButton && prevButton
        ? {
            nextEl: nextButton,
            prevEl: prevButton,
          }
        : false,
      breakpoints: {
        750: {
          slidesPerView: desktopSlides,
          spaceBetween: desktopGap,
          autoHeight: false,
        },
      },
      a11y: {
        prevSlideMessage: 'Previous review',
        nextSlideMessage: 'Next review',
      },
    });
  });
}

function initSharedSwipers(root) {
  initBannerSliders(root);
  initUspSliders(root);
  initShopByCategorySliders(root);
  initFeaturedBlogPostSliders(root);
  initCustomReviewSliders(root);
}

window.initSharedSwipers = initSharedSwipers;
window.initShopByCategorySliders = initShopByCategorySliders;
window.initFeaturedBlogPostSliders = initFeaturedBlogPostSliders;
window.initCustomReviewSliders = initCustomReviewSliders;

document.addEventListener('DOMContentLoaded', function () {
  initSharedSwipers(document);
});

document.addEventListener('shopify:section:load', function (event) {
  initSharedSwipers(event.target);
});

window.addEventListener('resize', function () {
  initUspSliders(document);
  initFeaturedBlogPostSliders(document);
  initCustomReviewSliders(document);
});
